import React from 'react'
import {
  PlanBoxLetsTalk,
  EnterprisePlanUnlimited,
  EnterpriseUpBold,
  StartFreeTrialButton,
} from 'Features/pricing/components/PlanBox/PlanBox.styled'
import { Trans, useTranslation } from 'react-i18next'

type EnterprisePlanProps = {
  hideCustomPricingTitle?: boolean
  handleClick?: () => void
  crossSell?: boolean
  bundle?: boolean
}

export const EnterprisePlan = ({
  hideCustomPricingTitle,
  handleClick,
  crossSell,
  bundle,
}: EnterprisePlanProps) => {
  const { t } = useTranslation('pricing')
  return (
    <>
      {!hideCustomPricingTitle && (
        <PlanBoxLetsTalk>{t('paid_marketing.custom_pricing')}</PlanBoxLetsTalk>
      )}
      {!bundle && !crossSell && (
        <StartFreeTrialButton onClick={handleClick} text={t('lets_talk')} />
      )}
      <EnterprisePlanUnlimited>
        <Trans ns="pricing" i18nKey="unlimited_websites">
          protected websites <EnterpriseUpBold>Unlimited</EnterpriseUpBold>
        </Trans>
      </EnterprisePlanUnlimited>
      <EnterprisePlanUnlimited style={{ marginTop: '12px' }}>
        <Trans ns="pricing" i18nKey="paid_marketing.unlimited_visits">
          yearly visits <EnterpriseUpBold>Unlimited</EnterpriseUpBold>
        </Trans>
      </EnterprisePlanUnlimited>
    </>
  )
}
